import { Box, Modal, Typography } from "@mui/material";
import React from "react";

const Box_Modal = ({ open, handleOpenClose, message, title, rejectmodal }) => {
  const handleClose = () => handleOpenClose(!open);

  const modalStyle = {
    position: "absolute",
    top: "50%", 
    left: "50%",
    transform: "translate(-50%, -50%)", 
    width: rejectmodal ? "auto" : "50%", 
    maxHeight: "90vh", 
    bgcolor: "#FFFFFF",
    border: "2px solid #000",
    boxShadow: 24,
    p: rejectmodal ? 1 : 4,
    textAlign: "center",
    overflow: "hidden", 
  };

  const contentStyle = {
    maxHeight: "calc(90vh - 100px)", 
    overflowY: "auto", 
    paddingBottom: "10px", 
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{ fontWeight: "bold", marginBottom: 2 }}
        >
          {title}
        </Typography>
        <Box sx={contentStyle}>
          <Typography
            id="modal-modal-description"
            variant="h6"
            component="p"
            sx={{ margin: 1 }}
          >
            {message}
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default Box_Modal;
